<template>
  <nav class="breadcrumb has-bullet-separator">
    <ul style="flex-wrap: nowrap">
      <slot></slot>
    </ul>
  </nav>
</template>

<script>
 export default {
   props: {
     items: {
       type: Array,
       default: () => []
     }
   }
 }
</script>
